import { StyledAlert } from "App/global-style";
import { AlertType } from "Components/Form/Alert";
import { AddProductToCartEntity } from "Store/addProductToCart/interfaces";
import { ApiErrorOld } from "Store/interfaces/products";
import { isDefined } from "Utils/functions";
import React from "react";

interface Props {
  addProductToCart: AddProductToCartEntity;
}

export const AddAdviceProductsToCartError = ({
  addProductToCart,
}: Props): React.ReactElement | null => {
  if (!isDefined(addProductToCart.error)) {
    return null;
  }

  // TODO - Reponse from commerce is returned as a html string. This is a temporary cast until we get a proper error response from commerce.
  const responseAsString = addProductToCart.error.response as
    | string
    | ApiErrorOld;

  if (
    typeof responseAsString === "string" &&
    responseAsString.includes("504")
  ) {
    return (
      <StyledAlert
        alertId="addProductToCart-timeout"
        alertType={AlertType.SYSTEM_ERROR_ALERT}
        title="Dette tok litt lenger tid enn forventet"
        type="error"
        fluid
      >
        Dette kallet timet ut. Vent 30 sekunder og oppdater siden ved å trykke
        på refresh-knappen i nettleseren. Hvis produktene i handlekurven ikke er
        oppdatert, kan du prøve å legge til produktene på nytt. Hvis problemet
        vedvarer, ta kontakt med support.
      </StyledAlert>
    );
  }

  return (
    <StyledAlert
      alertId="addProductToCart"
      alertType={AlertType.SYSTEM_ERROR_ALERT}
      title="Det har skjedd en feil hos oss"
      type="error"
      fluid
    >
      Vi klarte ikke å legge produktene i handlekurven. Du kan prøve igjen om en
      liten stund, eller ta kontakt med support.
    </StyledAlert>
  );
};
